var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("SidebarWidget", {
    attrs: {
      title: _vm.$gettext("Seitenausrichtung"),
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function fn() {
          return [
            _c("label", [
              _c(
                "span",
                {
                  staticClass: "sr-only",
                },
                [
                  _vm._v(
                    _vm._s(_vm.$gettext("Wählen Sie eine Seitenausrichtung"))
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.orientation,
                      expression: "orientation",
                    },
                  ],
                  staticClass: "sidebar-selectlist",
                  on: {
                    change: function change($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.orientation = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                _vm._l(Object.entries(_vm.orientations), function (_ref) {
                  var value = _ref[0],
                    text = _ref[1].text
                  return _c(
                    "option",
                    {
                      key: value,
                      domProps: {
                        value: value,
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(text) +
                          "\n                "
                      ),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }